import { SignalRService } from './signalr';

export const SignalR = new SignalRService();
export * from './types';
